import UserActionTypes from './user-types';

const INITIAL_STATE = {
  currentUser: undefined,
  userRol: undefined,
  userNivel: undefined,
  estatusRegistro:undefined,
  datosAspirante:undefined,
  exito:undefined,
  estadoDistritoAspirante:undefined,
  fechaHoraActividad:undefined
};

const userReducer = (state = INITIAL_STATE, action) => {
  switch (action.type) {
    case UserActionTypes.SET_CURRENT_USER:
      return {
        ...state,
        currentUser: action.payload
      }
    case UserActionTypes.SET_CURRENT_USER_ROL:
      return {
        ...state,
        userRol: action.payload
      }
    case UserActionTypes.SET_CURRENT_USER_NIVEL:
      return {
        ...state,
        userNivel: action.payload
      }
    case UserActionTypes.CAMBIAR_ESTATUS:
			if (!state.datosAspirante)
				state.datosAspirante = {};

			state.datosAspirante.estatusRegistro = action.payload;

			return {
        ...state
      }
    case UserActionTypes.IMPLANTACION_ASPIRANTE:
      return {
        ...state,
        datosAspirante: action.payload
      }
    case UserActionTypes.REGISTRO_TERMINADO:
      return {
        ...state,
        exito: action.payload
      }
    case UserActionTypes.SET_ESTADO_DISTRITO_ASPIRANTE:
      return {
        ...state,
        estadoDistritoAspirante: action.payload
      }
    case UserActionTypes.SET_FECHA_HORA_ACTIVIDAD:
      return {
        ...state,
        fechaHoraActividad : action.payload
      }
    default:
      return state;
  }
};

export default userReducer;